// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  kind: __t.string(),
  name: __t.string(),
  order: __t.f64(),
  muted: __t.bool(),
  hidden: __t.bool(),
  locked: __t.bool(),
  solo: __t.bool(),
  volume: __t.f64(),
  pan: __t.f64(),
  scopeId: __t.string().name("scope_id"),
  groupName: __t.string().name("group_name"),
  motion: __t.string(),
});
